export default __webpack_public_path__ + "static/media/attach_files.8d58c55d.svg";